module.exports = __webpack_public_path__ + "img/春运天气@2x.1da9a6dd.png";